<template>
  <div class="modal">
    <header class="modal__title">
      {{ title }}
    </header>

    <section class="modal__content">
      {{ content }}
    </section>

    <footer class="modal__bottom">
      <button type="button" class="modal__btn modal__btn--gray" @click="$emit('close')">
        {{ btnCloseText }}
      </button>

      <button type="button" class="modal__btn" @click="confirm()">
        {{ btnConfirmText }}
      </button>
    </footer>
  </div>
</template>

<script>
  export default {
    name: 'ConfirmModal',
    props: {
      title: String,
      content: String,
      btnCloseText: String,
      btnConfirmText: String,
      handleConfirm: Function
    },
    methods: {
      confirm() {
        this.handleConfirm();
        this.$emit('close');
      }
    }
  };
</script>

<style scoped lang="scss">
  $white: #fff;
  $modal-title-color: #3b4d5c;
  $btn-gray: #cfcfcf;
  $btn-light-blue: #49c3dd;
  $btn-blue: #2b7ec0;

  .modal {
    background: $white;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
    border-radius: 17px;
    padding: 44px 37px;

    &__title {
      font-size: 2.8rem;
      font-weight: bold;
      line-height: 1.68;
      text-align: center;
      color: $modal-title-color;
      margin-bottom: 0.7em;

      @media (max-width: 460px) {
        font-size: 2rem;
        line-height: 1.2;
      }
    }

    &__content {
      color: rgba($modal-title-color, 0.8);
      font-size: 2rem;
      line-height: 1.8;
      text-align: center;

      @media (max-width: 460px) {
        font-size: 1.5rem;
        line-height: 1.2;
      }
    }

    &__bottom {
      margin: 30px 0 10px;
      display: flex;
      justify-content: center;
      align-items: center;

      @media (max-width: 460px) {
        flex-direction: column;
      }
    }

    &__btn {
      min-width: 150px;
      padding: 9px 0;
      border-radius: 8px;
      border: none;
      background: linear-gradient(113deg, $btn-light-blue, $btn-blue);
      cursor: pointer;
      font-size: 1.9rem;
      font-weight: bold;
      line-height: 2.47;
      text-align: center;
      color: $white;

      &--gray {
        background: $btn-gray;
      }

      &:last-child {
        margin-left: 1.26em;

        @media (max-width: 460px) {
          margin-left: 0;
          margin-top: 1em;
        }
      }

      @media (max-width: 460px) {
        font-size: 1.5rem;
        line-height: 1.2;
      }
    }

    .modal__btn {
      min-width: 150px;
      padding: 9px 0;
      border-radius: 8px;
      border: none;
      background: linear-gradient(113deg, $btn-light-blue, $btn-blue);
      cursor: pointer;
      font-size: 1.9rem;
      font-weight: bold;
      line-height: 2.47;
      text-align: center;
      color: $white;

      &:focus {
        outline: 0;
      }

      &--gray {
        background: $btn-gray;
      }

      &:last-child {
        margin-left: 1.26em;

        @media (max-width: 460px) {
          margin-left: 0;
          margin-top: 0.7em;
        }
      }

      @media (max-width: 460px) {
        font-size: 1.5rem;
        line-height: 1.2;
      }
    }

    @media (max-width: 768px) {
      margin: 0 10px;
    }

    @media (max-width: 460px) {
      padding: 22px 27px;
    }
  }
</style>
